export enum ModuleConfigOtherParametersEnum {
  BRAND,
  DIVISION
}
